import React, { useRef, useEffect, useState } from "react";
import style from "css/landing.module.css";
import Questions from "components/app/questions";
import Slogan from "components/landing/slogan";
import Project from "components/landing/project";
import Technology from "components/landing/technology";
import History from "components/landing/history";
import Partners from "components/landing/partners";
import News from "components/landing/news";
import Social from "components/landing/social";
import SEOMeta from "components/app/SEOMeta";
import Visual from "components/landing/visual";
/**
 * 파일명: Landing.js
 * 작성자: 강연승
 * 작성일자: 25.02.06
 * 설명: Landing page
 */

function Landing(props) {
  const mainRef = useRef(null);
  const sloganRef = useRef(null);
  const projectRef = useRef(null);

  const sections = [mainRef, sloganRef];

  const [sloganBoxStyle, setSloganBoxStyle] = useState({
    scale: 0,
    opacity: 0,
  });

  const [isOneScroll, setIsOneScroll] = useState(true);
  // 도형 스케일 다 커졌는지 상태 추가
  const [canScrollNext, setCanScrollNext] = useState(false);

  const textColor = sloganBoxStyle.scale >= 0.9 ? "#000" : "#fff";

  const scaleRef = useRef(sloganBoxStyle.scale);

  // Ref에 최신 상태 저장
  const canScrollNextRef = useRef(canScrollNext);
  const isOneScrollRef = useRef(isOneScroll);

  const handleClick = () => {
    projectRef.current.scrollIntoView({ behavior: "smooth" });
  };

  // useEffect(() => {
  //   scaleRef.current = sloganBoxStyle.scale;
  //   canScrollNextRef.current = canScrollNext;
  //   isOneScrollRef.current = isOneScroll;
  // }, [sloganBoxStyle.scale, canScrollNext, isOneScroll]);

  const handleScroll = () => {
    if (!sloganRef.current) return;
    const rect = sloganRef.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const scrollRange = windowHeight + rect.height * 0.3; // 범위 확장
    const visibleRatio = Math.min(
      Math.max((windowHeight - rect.top) / scrollRange, 0),
      1,
    );
    setSloganBoxStyle({
      scale: visibleRatio,
      opacity: visibleRatio,
    });

    // visibleRatio가 거의 1이면 canScrollNext=true, 아니면 false
    if (visibleRatio >= 1 && !canScrollNextRef.current) {
      setCanScrollNext(true);
      projectRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (visibleRatio < 1 && canScrollNextRef.current) {
      setCanScrollNext(false);
    }
  };

  // useEffect(() => {
  //   props.containerRef?.current?.addEventListener("scroll", handleScroll);
  //   handleScroll(); // 초기값 세팅
  //   return () =>
  //     props.containerRef?.current?.removeEventListener("scroll", handleScroll);
  // }, []);

  // useEffect(() => {
  //   const handleWheel = (e) => {
  //     if (isOneScrollRef.current) {
  //       e.preventDefault();

  //       const currentSection = sections.findIndex(
  //         (section) => section.current.getBoundingClientRect().top >= 0,
  //       );

  //       if (e.deltaY > 0 && currentSection < sections.length - 1) {
  //         // 스크롤 다운
  //         sections[currentSection + 1].current.scrollIntoView({
  //           behavior: "smooth",
  //         });
  //       } else if (e.deltaY < 0 && currentSection > 0) {
  //         // 스크롤 업
  //         sections[currentSection - 1].current.scrollIntoView({
  //           behavior: "smooth",
  //         });
  //       }
  //     }
  //   };

  //   const handleScrollCheck = () => {
  //     if (sloganRef.current) {
  //       const targetPosition = sloganRef.current.getBoundingClientRect().top;
  //       if (targetPosition <= 0) {
  //         setIsOneScroll(false);
  //         // if (isOneScrollRef.current !== false) {
  //         //   setIsOneScroll(false);
  //         // }
  //       } else {
  //         setIsOneScroll(true);
  //         // if (isOneScrollRef.current !== true) {
  //         //   setIsOneScroll(true);
  //         // }
  //       }
  //     }
  //   };

  //   props.containerRef?.current?.addEventListener("wheel", handleWheel, {
  //     passive: false,
  //   });
  //   props.containerRef?.current?.addEventListener("scroll", handleScrollCheck);

  //   return () => {
  //     props.containerRef?.current?.removeEventListener("wheel", handleWheel);
  //     props.containerRef?.current?.removeEventListener(
  //       "scroll",
  //       handleScrollCheck,
  //     );
  //   };
  // }, [
  //   // sections,
  //   // props.containerRef,
  //   isOneScrollRef.current,
  // ]);

  // useEffect(() => {
  //   const onScroll = () => {
  //     if (!props.containerRef?.current) return;

  //     // 스크롤 컨테이너가 window면 window.scrollY, 아니면 scrollTop 사용
  //     const scrollTop =
  //       props.containerRef.current === window
  //         ? window.scrollY
  //         : props.containerRef.current.scrollTop;

  //     // console.log("scrollTop:", scrollTop);
  //   };

  //   const target = props.containerRef?.current || window;

  //   target.addEventListener("scroll", onScroll);

  //   return () => target.removeEventListener("scroll", onScroll);
  // }, [props.containerRef]);

  return (
    <>
      <SEOMeta
        title="리브테크놀로지, riv Technology"
        description="리브테크놀로지는 스마트워크와 원격진료 솔루션을 개발.제공하는 소프트웨어 전문 기업입니다."
        keywords="riv, riv Technology, neat, 스마트 회의실, 화상회의"
      />
      {/* <div
        className={style.landing_wrap}
        ref={mainRef}
      >
        <div className={style.background}>
          <video
            src={`${process.env.REACT_APP_CLIENT_URL}video/landing.mp4`}
            autoPlay={true}
            muted={true}
            loop={true}
            controls={false}
          ></video>
        </div>
        <div className={style.background_overlay} />
        <div className={style.landing_logo_wrap}>
          <div className={style.lading_logo_text_wrap}>
            <img
              src={`${process.env.REACT_APP_CLIENT_URL}img/landing/riv.webp`}
              alt="logo"
            />
            <p className={style.landing_logo_text}>
              {"One Platform\nfor Hybrid System."}
            </p>
          </div>
          <img
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/landing/technology.webp"
            }
            alt="logo"
          />
        </div>
        <button className={style.landing_scroll_guide_btn}>SCROLL</button>
      </div> */}
      {/* <Slogan
        skip={handleClick}
        ref={sloganRef}
        boxStyle={sloganBoxStyle}
        textColor={textColor}
      /> */}
      <Visual />
      <Project ref={projectRef} />
      <Technology />
      <History />
      <Partners />
      {/* <News /> */}
      <Social />
      <Questions />
    </>
  );
}

export default Landing;
